
import { Box, Paper, Link } from "@mui/material";
import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { useTranslate } from "../components/Translate/TranslateContext";
import SetupBar from "../components/Layout/SetupBar";
import AnimatedIcons from "../components/Layout/AnimatedIcons";

import UserRegistration from "../components/Register/UserRegistration";
import TermsAndConditions from "../components/Register/TermsAndConditions";
import EmailVertification from "../components/Register/EmailVerification";

import { submitUserRegistration } from "../api/userRegistration";

export default function Register({ user, setUser }) {
    const { translate } = useTranslate();
    const navigate = useNavigate();

    const [userForm, setUserForm] = useState({
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        country: "",
        country_code: "",
        region: "",
    });

    const status = user?.account_status ?? "user_registration";

    const handleUserSubmit = async (form) => {
        console.log(form.country_code);
        const payload = {
            ...form,
            country: form.country_code,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        const result = await submitUserRegistration(payload);

        setUser({
            ...user,
            ...result.user,
            account_status: "terms_and_conditions",
        });
    };

    const handleLogout = () => {
        setUser(null);
        navigate("/");
    };
    const stepComponent = useMemo(() => ({
        user_registration: (
            <UserRegistration
                form={userForm}
                setForm={setUserForm}
                onSubmit={handleUserSubmit}
            />
        ),

        terms_and_conditions: (
            <TermsAndConditions
                user={user}
                onAccepted={(next) =>
                    setUser((prev) => ({
                        ...prev,
                        account_status: next || "finished",
                    }))
                }
            />
        ),

        email_vertification: (
            <EmailVertification
                user={user}
                setUser={setUser}
            />
        ),
    }), [user, userForm]);

    return (
        <Box
            sx={{
                minHeight: "500px",
                px: { xs: 2, md: 1 },
                py: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
            }}
        >
            <AnimatedIcons mono />

            <Box sx={{ width: "100%", maxWidth: 1200, zIndex: 5 }}>
                <Link
                    component="button"
                    onClick={handleLogout}
                    sx={{
                        mb: 2,
                        color: "var(--color-text-inverse)",
                        textAlign: "left",
                    }}
                >
                    {translate("back_to_login")}
                </Link>

                <Paper
                    elevation={0}
                    sx={{
                        width: "100%",
                        borderRadius: 2,
                        backgroundColor: "var(--color-bg-primary)",
                        overflow: "hidden",
                    }}
                >
                    <SetupBar      Status={status} Type="user" />
                    {stepComponent[status]}
                </Paper>
            </Box>
        </Box>
    );
}